import { createAsyncThunk } from '@reduxjs/toolkit';

import { VendorsResponseSchema } from '../types/VendorsSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const assignVendorToProperty = createAsyncThunk<
    VendorsResponseSchema,
    { vendorId: string; propertyId: string },
    ThunkConfig<string>
>('vendors/assignToProperty', async ({ vendorId, propertyId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.post<VendorsResponseSchema>(
            `/v1/properties/${propertyId}/vendors`,
            {
                vendorId,
            },
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
